import { useEffect, useState } from "react";
import { getUserAuthTagById } from "../services/authTagService";

interface IUseFetchAuthTagById {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  authTagId: string | null;
}

const useFetchAuthTagById = ({ setIsLoading, authTagId }: IUseFetchAuthTagById) => {
  const [authTagData, setAuthTagData] = useState<any>(null);

  useEffect(() => {
    if (!authTagId) {
      setAuthTagData(null);
      return;
    }

    setIsLoading(true);
    const getAuthTagData = async () => {
      try {
        const res = await getUserAuthTagById(authTagId);
        setAuthTagData(res);
      } catch (err) {
        setAuthTagData(null);
      } finally {
        setIsLoading(false);
      }
    };
    getAuthTagData();
  }, [setIsLoading, authTagId]);

  return [authTagData];
};

export default useFetchAuthTagById;
